import React from 'react';

import { I18n } from 'common/i18n';
import { ForgeIcon } from '@tylertech/forge-react';

export const BackButton = (props: { onClick: () => void }) => {
  return (
    <button className="btn btn-default btn-sm back-button" onClick={props.onClick}>
      <ForgeIcon name="arrow_back" slot="start"></ForgeIcon>
      {` ${I18n.t('common.action_buttons.back')}`}
    </button>
  );
};
